import type { StreamingBlock } from "@storytell/streaming";
import { BlockRenderer } from "@storytell/streaming";
import type { IconTypes } from "solid-icons";
import { TbClipboardList, TbFileText, TbInfoCircle, TbSparkles, TbWand } from "solid-icons/tb";
import type { JSX } from "solid-js";

const VARIANT_CLASSES = {
  blue: "text-blue-600 dark:text-blue-400",
  purple: "text-purple-600 dark:text-purple-400",
  green: "text-green-600 dark:text-green-400",
  gray: "text-gray-600 dark:text-gray-400",
} as const;

interface IconConfig {
  size?: number;
  variant?: keyof typeof VARIANT_CLASSES;
}

const icons: Record<BlockRenderer, IconTypes> = {
  [BlockRenderer.USER_FACING_MESSAGE]: TbSparkles,
  [BlockRenderer.ARTIFACT_VIEWER]: TbFileText,
  [BlockRenderer.TASK_CARD]: TbClipboardList,
  [BlockRenderer.BLOCK_PREVIEW]: TbInfoCircle,
  [BlockRenderer.INTERSTITIAL]: TbInfoCircle,
  [BlockRenderer.PROMPT_ACK]: TbInfoCircle,
  [BlockRenderer.INTERSTITIAL_DATA]: TbInfoCircle,
  [BlockRenderer.INTERSTITIAL_CATCH]: TbInfoCircle,
  [BlockRenderer.INTERSTITIAL_USER_FACING]: TbInfoCircle,
  [BlockRenderer.TURN_COMPLETE]: TbInfoCircle,
  [BlockRenderer.CHAT_SEARCH_RESULTS]: TbInfoCircle,
  [BlockRenderer.SKILLS]: TbWand,
  [BlockRenderer.UNKNOWN]: TbInfoCircle,
};

export const getBlockIconComponent = (
  _block: StreamingBlock,
  preferredRenderer: BlockRenderer,
  config: IconConfig = {}
): JSX.Element => {
  const { size = 16 } = config;

  let rendererIcon = TbInfoCircle;
  const preferredIcon = icons[preferredRenderer];
  if (preferredIcon) {
    rendererIcon = preferredIcon;
  }

  const IconComponent = rendererIcon;
  return <IconComponent size={size} />;
};
